import { render, staticRenderFns } from "./BaseAppLogo.vue?vue&type=template&id=33c376e8&"
import script from "./BaseAppLogo.vue?vue&type=script&lang=js&"
export * from "./BaseAppLogo.vue?vue&type=script&lang=js&"
import style0 from "./BaseAppLogo.vue?vue&type=style&index=0&id=33c376e8&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c376e8')) {
      api.createRecord('33c376e8', component.options)
    } else {
      api.reload('33c376e8', component.options)
    }
    module.hot.accept("./BaseAppLogo.vue?vue&type=template&id=33c376e8&", function () {
      api.rerender('33c376e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseAppLogo.vue"
export default component.exports